// "async" opts into server-side search: the parent supplies pre-filtered `options` and an
// `onSearchChange` handler it uses to refetch. Sync (default) filters `options` client-side.
export const SELECT_MODES = { SYNC: "sync", ASYNC: "async" };
